import { render, staticRenderFns } from "./PwRequestForm.vue?vue&type=template&id=3c9b0158&"
import script from "./PwRequestForm.vue?vue&type=script&lang=ts&"
export * from "./PwRequestForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports